import classNames from 'classnames'
import React from 'react'

enum TagSize {
  small = 'h-4 min-w-4', // 16px height
  medium = 'h-5 min-w-5', // 20px height
  large = 'min-w-5',
}
type TagSizeType = keyof typeof TagSize

enum TagPadding {
  small = 'px-[5px] py-0', // 16px height
  medium = 'px-1.5 py-0.5', // 20px height
  large = 'p-3',
}
type TagPaddingType = keyof typeof TagPadding

enum TagFont {
  small = 'text-3xs leading-3', // 10px/12px
  medium = 'text-2xs leading-4', // 12px/16px
  large = 'text-sm',
}

enum TagVariant {
  filled = 'border border-bg-primary bg-gray-50 text-gray-600 font-medium dark:bg-gray-600 dark:text-gray-50',
  bordered = 'border border-primary text-muted',
}

type TagVariantType = keyof typeof TagVariant

enum TagRounding {
  small = 'rounded-sm',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  medium = 'rounded-sm',
  large = 'rounded-md',
}

type TagProps = {
  size?: TagSizeType
  padding?: TagPaddingType
  variant?: TagVariantType
  className?: string
}

export function Tag({
  className,
  size = 'medium',
  padding = size,
  variant = 'filled',
  children,
}: React.PropsWithChildren<TagProps>) {
  const tagPadding = TagPadding[padding]
  const tagSize = TagSize[size]
  const tagFont = TagFont[size]
  const tagRounding = TagRounding[size]
  const tagVariant = TagVariant[variant]

  return (
    <span
      className={classNames(
        className,
        'inline-flex items-center justify-center',
        tagPadding,
        tagRounding,
        tagVariant,
        tagSize,
        tagFont
      )}
    >
      {children}
    </span>
  )
}
